import { FeedbackTypeEnum } from '@shared/models/feedback';
import * as yup from 'yup';

export const values = [
  { value: FeedbackTypeEnum.BugError, label: 'Bug/error' },
  { value: FeedbackTypeEnum.ExistingFeatureImprovement, label: 'Existing feature improvement' },
  { value: FeedbackTypeEnum.NewFeatureRequestSuggestion, label: 'New feature request/suggestion' },
  { value: FeedbackTypeEnum.NewDocumentResourceAdditionRequest, label: 'New document/resource addition request' },
  { value: FeedbackTypeEnum.OtherGeneralFeedback, label: 'Other/General feedback' },
];
export interface FeedbackForm {
  type: string;
  message: string;
}

export const initValues: FeedbackForm = { message: '', type: FeedbackTypeEnum.OtherGeneralFeedback };

export const schema = yup.object({
  type: yup.string().required('Field is required'),
  message: yup.string().required().min(20).max(500, 'Description cannot exceed 500 characters.'),
});
